export const FREE_PLAN_ID = 'plan-anima-free';
export const DOWNGRADE_PLAN_INTENTION = 'DOWNGRADE_PLAN';

export const isDowngradeToFreeSelection = (planId, intentionType) =>
  planId === FREE_PLAN_ID && intentionType === DOWNGRADE_PLAN_INTENTION;

export const openExternalUrl = (url) => {
  const externalWindow = window.open(url, '_blank', 'noopener,noreferrer');

  if (!externalWindow) {
    window.location.href = url;
  }
};
